import { SavedTab, SavedType, SavedView } from "@/types/saved"

import { getAllPlaceTypes } from "@/lib/entity-utils"

export const SAVED_TAB_PLACES: SavedTab = "places"
export const SAVED_TAB_COLLECTIONS: SavedTab = "collections"
export const SAVED_TAB_GUIDES: SavedTab = "guides"

export const SAVED_VIEW_TRIPS: SavedView = "trips"
export const SAVED_VIEW_MAP: SavedView = "map"

export const SAVED_TYPE_DEFAULT: SavedType = "all"
export const SAVED_TAB_DEFAULT: SavedTab = SAVED_TAB_COLLECTIONS
export const SAVED_DEFAULT_VIEW: SavedView = undefined

export const SAVED_MAP_ID = "saved-map"

export const SAVED_TAB_VALUES: SavedTab[] = [
  SAVED_TAB_PLACES,
  SAVED_TAB_COLLECTIONS,
  SAVED_TAB_GUIDES,
] as const

export const SAVED_TYPE_VALUES: SavedType[] = [
  "all",
  ...getAllPlaceTypes(),
] as const

export const PLACE_COLLECTIONS_PER_PAGE = 20
export const SAVE_DIALOG_SEARCH_MIN_COLLECTIONS = 10
export const SAVE_DIALOG_SEARCH_MIN_QUERY_LENGTH = 2

export const SAVED_RECENT_SEARCHES_STORAGE_KEY = "savedRecentSearches"
export const SAVED_RECENT_SEARCHES_MAX = 5
